import { Box, Button, CircularProgress, Container, Fade } from '@mui/material';
import { makeStyles, ThemeProvider } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Title from '../../../components/Layout/Title';
import MUIDataTable from 'mui-datatables';
import ActivitatsColumns from './ActivitatsColumns';
import TableOptions from '../../../components/TableOptions';
import { getElements } from '../../../database/API';
import { Plus } from 'react-feather';
import getMuiTheme from '../../../theme/TableStyle';
import Loading from '../../../components/Layout/Loading';
import CustomButton from '../../../components/CustomButton';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingBottom: 80,
    },
    '@global': {
        html: {
            width: '100%',
            height: '100%',
        },
    },
}));

const ActivitatsAdmin = () => {
    const classes = useStyles();
    const [activitats, setActivitats] = useState([]);
    const [loading, setLoading] = useState(true);
    const columns = ActivitatsColumns(activitats);
    const navigate = useNavigate();

    useEffect(() => {
        const get = async () => {
            const { result } = await getElements('activitats?lang_ab=ca');
            setActivitats(result);
            setLoading(false);
        };

        get();
    }, []);

    const CustomToolbar = () => {
        return (
            <CustomButton
                onClick={() => navigate('/admin/activitats/add')}
                title={
                    <>
                        <Plus size={15} /> Nova Activitat
                    </>
                }
            />
        );
    };
    const options = TableOptions(CustomToolbar);

    return (
        <Box className={classes.container}>
            <Title title="Activitats" />
            <Container maxWidth="xl">
                <Loading loading={loading}>
                    <Box pt={4} spacing={3}>
                        <ThemeProvider theme={getMuiTheme()}>
                            <MUIDataTable
                                data={activitats}
                                columns={columns}
                                options={options}
                            />
                        </ThemeProvider>
                    </Box>
                </Loading>
            </Container>
        </Box>
    );
};

export default ActivitatsAdmin;
